<template>
  <div v-bind:class="`form-group ${formGroupClass} ${ (error) ? 'has-danger' : '' }`">
    <slot>
    </slot>
    <span v-show="error" v-bind:class="`help-block red-600 ${errorTextClass}`">{{ error }}</span>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: null,
    },
    formGroupClass: {
      type: String,
      default: '',
    },
    errorTextClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
/*
.form-group {
  max-width: 600px;
}
*/

label {
  /*padding: .429rem 0;*/
}

.form-group-footer {
  margin-top: 32px;
}

.default-form .form-group, .user-form .form-group {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// FormGroup.vue?71d96934